import { FETCH_PATIENT_VISITS_START, FETCH_PATIENT_VISITS_SUCCESS, FETCH_PATIENT_VISITS_ERROR, ADD_UPDATE_VISIT_START, ADD_UPDATE_VISIT_SUCCESS, ADD_UPDATE_VISIT_ERROR, DELETE_PATIENT_EXAMINATION_SUCCESS, DELETE_PATIENT_EXAMINATION_ERROR, RESET_PATIENT_VISITS, UPLOAD_VISIT_DOCUMENT_SUCCESS, UPLOAD_VISIT_DOCUMENT_ERROR } from "../../actions/receptionist/visitsAction";
import _ from "lodash";
import { FETCH_ALL_RADIOLOGISTS_ERROR, FETCH_ALL_RADIOLOGISTS_START, FETCH_ALL_RADIOLOGISTS_SUCCESS } from "../../actions/receptionist/radiologistsAction";

const INIT_STATE = {
    error: "",
    loading: false,
    submitting: false,
    message: '',
    radiologists: []
};

const radiologistsReducer = (state = INIT_STATE, action) => {
    let newState;
    let newVisits;
    let index;
    switch (action.type) {
        case FETCH_ALL_RADIOLOGISTS_START: {
            return { ...state, error: '', message: '', loading: true };
        }
        case FETCH_ALL_RADIOLOGISTS_SUCCESS: {
            return { ...state, error: '', message: '', loading: false, radiologists: [...action.radiologists] };

        }
        case FETCH_ALL_RADIOLOGISTS_ERROR: {
            return { ...state, error: action.error, message: '', loading: false };
        }

        default:
            return state;
    }
}

export default radiologistsReducer;